<p>vault-file-download works!</p>
